"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var lodash_1 = require("lodash");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var utils_1 = require("../utils");

var entities_1 = require("../entities");
/**
 * @hidden
 */


exports.createTieredStoFactoryRefreshResolver = function (tieredStoFactory, addedTransactions, tag, tieredStoId) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(addedTransactions[addedTransactions.length - 1] === tag)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", tieredStoFactory.refresh(tieredStoId));

            case 2:
              return _context.abrupt("return", undefined);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * Procedure that modifies the configuration parameters of a Tiered STO
 */


var ModifyTieredStoData =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(ModifyTieredStoData, _Procedure_1$Procedur);

  function ModifyTieredStoData() {
    var _this2;

    _classCallCheck(this, ModifyTieredStoData);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ModifyTieredStoData).apply(this, arguments));
    _this2.type = types_1.ProcedureType.ModifyTieredStoData;
    return _this2;
  }
  /**
   * - Modify the start and end date of the STO
   * - Modify the fundraise types of the STO
   * - Modify the custom currency symbol and the oracles used to convert POLY and ETH to said currency
   * - Modify the STO's tiers (rates, tokens per tier and discounts when buying with POLY)
   * - Modify investment limits (min investment, max invested for non-accredited investors)
   * - Modify treasury wallet, wallet for unsold tokens and stable coin addresses
   *
   * Only transactions that will effectively present changes will be submitted
   *
   * Note that this procedure will fail if:
   * - The STO has not been enabled or has been archived
   * - The STO has already started
   * - Attempting to use a custom currency on an STO with version 3.0.0 or lower
   * - The supplied parameters don't represent any changes in the STO
   */


  _createClass(ModifyTieredStoData, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var args, context, symbol, stoAddress, startDate, endDate, tiers, nonAccreditedInvestmentLimit, minimumInvestment, currencies, raisedFundsWallet, unsoldTokensWallet, stableCoinAddresses, customCurrency, contractWrappers, tieredStoFactory, stoModule, securityTokenId, tieredStoId, _ref, _ref2, sto, treasuryWallet, investmentLimit, minInvestment, startTime, endTime, storageWallet, allTiers, fundraiseCurrencies, usdTokens, _ref3, isRaisedInETH, isRaisedInPOLY, isRaisedInSC, addedTransactions, tag, willRaiseinEth, willRaiseinPoly, willRaiseinSc, areSameCurrencies, _tag, _ref4, _ref5, currentEthOracleAddress, currentPolyOracleAddress, denominatedCurrency, currentCustomCurrency, _customCurrency, currencySymbol, ethOracleAddress, polyOracleAddress, _tag2, areSameTiers, tokensPerTierTotal, tokensPerTierDiscountPoly, ratePerTier, ratePerTierDiscountPoly, _tag3, _tag4, areSameStablecoins, _tag5;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                args = this.args, context = this.context;
                symbol = args.symbol, stoAddress = args.stoAddress;
                startDate = args.startDate, endDate = args.endDate, tiers = args.tiers, nonAccreditedInvestmentLimit = args.nonAccreditedInvestmentLimit, minimumInvestment = args.minimumInvestment, currencies = args.currencies, raisedFundsWallet = args.raisedFundsWallet, unsoldTokensWallet = args.unsoldTokensWallet, stableCoinAddresses = args.stableCoinAddresses, customCurrency = args.customCurrency;
                contractWrappers = context.contractWrappers, tieredStoFactory = context.factories.tieredStoFactory;
                _context2.prev = 4;
                _context2.next = 7;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](4);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 12:
                _context2.next = 14;
                return contractWrappers.moduleFactory.getModuleInstance({
                  name: contract_wrappers_1.ModuleName.UsdTieredSTO,
                  address: stoAddress
                });

              case 14:
                stoModule = _context2.sent;

                if (stoModule) {
                  _context2.next = 17;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "STO ".concat(stoAddress, " is either archived or hasn't been launched")
                });

              case 17:
                securityTokenId = entities_1.SecurityToken.generateId({
                  symbol: symbol
                });
                tieredStoId = entities_1.TieredSto.generateId({
                  securityTokenId: securityTokenId,
                  stoType: types_1.StoType.Tiered,
                  address: stoAddress
                });
                _context2.next = 21;
                return Promise.all([tieredStoFactory.fetch(tieredStoId), contractWrappers.getTreasuryWallet({
                  module: stoModule
                })]);

              case 21:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 2);
                sto = _ref2[0];
                treasuryWallet = _ref2[1];
                investmentLimit = sto.nonAccreditedInvestmentLimit, minInvestment = sto.minimumInvestment, startTime = sto.startDate, endTime = sto.endDate, storageWallet = sto.raisedFundsWallet, allTiers = sto.tiers, fundraiseCurrencies = sto.fundraiseCurrencies, usdTokens = sto.stableCoinAddresses;
                _ref3 = [fundraiseCurrencies.includes(contract_wrappers_1.FundRaiseType.ETH), fundraiseCurrencies.includes(contract_wrappers_1.FundRaiseType.POLY), fundraiseCurrencies.includes(contract_wrappers_1.FundRaiseType.StableCoin)], isRaisedInETH = _ref3[0], isRaisedInPOLY = _ref3[1], isRaisedInSC = _ref3[2]; // STO can't have started

                if (!(startTime <= new Date())) {
                  _context2.next = 29;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'Cannot modify STO data: STO has already started'
                });

              case 29:
                // list of added transactions to keep track of the last added tx in order to refresh the entity only once
                addedTransactions = [];

                if (!startDate) {
                  startDate = startTime;
                }

                if (!endDate) {
                  endDate = endTime;
                }

                if (!(startDate !== startTime || endDate !== endTime)) {
                  _context2.next = 37;
                  break;
                }

                tag = types_1.PolyTransactionTag.ModifyTimes;
                addedTransactions.push(tag);
                _context2.next = 37;
                return this.addTransaction(stoModule.modifyTimes, {
                  tag: tag,
                  resolvers: [exports.createTieredStoFactoryRefreshResolver(tieredStoFactory, addedTransactions, tag, tieredStoId)]
                })({
                  startTime: startDate,
                  endTime: endDate
                });

              case 37:
                if (!currencies) {
                  currencies = [];

                  if (isRaisedInETH) {
                    currencies.push(types_1.Currency.ETH);
                  }

                  if (isRaisedInPOLY) {
                    currencies.push(types_1.Currency.POLY);
                  }

                  if (isRaisedInSC) {
                    currencies.push(types_1.Currency.StableCoin);
                  }
                }

                willRaiseinEth = currencies.includes(types_1.Currency.ETH);
                willRaiseinPoly = currencies.includes(types_1.Currency.POLY);
                willRaiseinSc = currencies.includes(types_1.Currency.StableCoin);
                areSameCurrencies = (!isRaisedInETH && !willRaiseinEth || isRaisedInETH && willRaiseinEth) && (!isRaisedInPOLY && !willRaiseinPoly || isRaisedInPOLY && willRaiseinPoly) && (!isRaisedInSC && !willRaiseinSc || isRaisedInSC && willRaiseinSc);

                if (areSameCurrencies) {
                  _context2.next = 47;
                  break;
                }

                _tag = types_1.PolyTransactionTag.ModifyFunding;
                addedTransactions.push(_tag);
                _context2.next = 47;
                return this.addTransaction(stoModule.modifyFunding, {
                  tag: _tag,
                  resolvers: [exports.createTieredStoFactoryRefreshResolver(tieredStoFactory, addedTransactions, _tag, tieredStoId)]
                })({
                  fundRaiseTypes: currencies
                });

              case 47:
                if (!contract_wrappers_1.isUSDTieredSTO_3_1_0(stoModule)) {
                  _context2.next = 69;
                  break;
                }

                _context2.next = 50;
                return Promise.all([stoModule.getCustomOracleAddress({
                  fundRaiseType: contract_wrappers_1.FundRaiseType.ETH
                }), stoModule.getCustomOracleAddress({
                  fundRaiseType: contract_wrappers_1.FundRaiseType.POLY
                }), stoModule.denominatedCurrency()]);

              case 50:
                _ref4 = _context2.sent;
                _ref5 = _slicedToArray(_ref4, 3);
                currentEthOracleAddress = _ref5[0];
                currentPolyOracleAddress = _ref5[1];
                denominatedCurrency = _ref5[2];
                currentCustomCurrency = {
                  currencySymbol: denominatedCurrency,
                  ethOracleAddress: currentEthOracleAddress,
                  polyOracleAddress: currentPolyOracleAddress
                };

                if (!customCurrency) {
                  customCurrency = currentCustomCurrency;
                }

                _customCurrency = customCurrency, currencySymbol = _customCurrency.currencySymbol, ethOracleAddress = _customCurrency.ethOracleAddress, polyOracleAddress = _customCurrency.polyOracleAddress;

                if (!currencySymbol) {
                  currencySymbol = denominatedCurrency;
                }

                if (!ethOracleAddress) {
                  ethOracleAddress = currentEthOracleAddress;
                }

                if (!polyOracleAddress) {
                  polyOracleAddress = currentPolyOracleAddress;
                }

                utils_1.checkStringLength(currencySymbol, 'denominated currency symbol');

                if (!(currencySymbol !== denominatedCurrency || ethOracleAddress !== currentEthOracleAddress || polyOracleAddress !== currentPolyOracleAddress)) {
                  _context2.next = 67;
                  break;
                }

                _tag2 = types_1.PolyTransactionTag.ModifyOracles;
                addedTransactions.push(_tag2);
                _context2.next = 67;
                return this.addTransaction(stoModule.modifyOracles, {
                  tag: _tag2,
                  resolvers: [exports.createTieredStoFactoryRefreshResolver(tieredStoFactory, addedTransactions, _tag2, tieredStoId)]
                })({
                  denominatedCurrencySymbol: currencySymbol,
                  customOracleAddresses: [ethOracleAddress, polyOracleAddress]
                });

              case 67:
                _context2.next = 71;
                break;

              case 69:
                if (!customCurrency) {
                  _context2.next = 71;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'Custom currency not supported in Tiered STO v3.0'
                });

              case 71:
                if (!tiers) {
                  tiers = allTiers;
                }

                areSameTiers = lodash_1.isEqual(tiers, allTiers);

                if (areSameTiers) {
                  _context2.next = 83;
                  break;
                }

                tokensPerTierTotal = [];
                tokensPerTierDiscountPoly = [];
                ratePerTier = [];
                ratePerTierDiscountPoly = [];
                tiers.forEach(function (_ref6) {
                  var tokensOnSale = _ref6.tokensOnSale,
                      tokensWithDiscount = _ref6.tokensWithDiscount,
                      price = _ref6.price,
                      discountedPrice = _ref6.discountedPrice;
                  tokensPerTierTotal.push(tokensOnSale);

                  if (tokensWithDiscount) {
                    tokensPerTierDiscountPoly.push(tokensWithDiscount);
                  }

                  if (discountedPrice) {
                    ratePerTierDiscountPoly.push(discountedPrice);
                  }

                  ratePerTier.push(price);
                });
                _tag3 = types_1.PolyTransactionTag.ModifyTiers;
                addedTransactions.push(_tag3);
                _context2.next = 83;
                return this.addTransaction(stoModule.modifyTiers, {
                  tag: _tag3,
                  resolvers: [exports.createTieredStoFactoryRefreshResolver(tieredStoFactory, addedTransactions, _tag3, tieredStoId)]
                })({
                  ratePerTier: ratePerTier,
                  tokensPerTierTotal: tokensPerTierTotal,
                  tokensPerTierDiscountPoly: tokensPerTierDiscountPoly,
                  ratePerTierDiscountPoly: ratePerTierDiscountPoly
                });

              case 83:
                if (!minimumInvestment) {
                  minimumInvestment = minInvestment;
                }

                if (!nonAccreditedInvestmentLimit) {
                  nonAccreditedInvestmentLimit = investmentLimit;
                }

                if (!(!minimumInvestment.isEqualTo(minInvestment) || !nonAccreditedInvestmentLimit.isEqualTo(investmentLimit))) {
                  _context2.next = 90;
                  break;
                }

                _tag4 = types_1.PolyTransactionTag.ModifyLimits;
                addedTransactions.push(_tag4);
                _context2.next = 90;
                return this.addTransaction(stoModule.modifyLimits, {
                  tag: _tag4,
                  resolvers: [exports.createTieredStoFactoryRefreshResolver(tieredStoFactory, addedTransactions, _tag4, tieredStoId)]
                })({
                  minimumInvestmentUSD: minimumInvestment,
                  nonAccreditedLimitUSD: nonAccreditedInvestmentLimit
                });

              case 90:
                if (!stableCoinAddresses) {
                  stableCoinAddresses = usdTokens;
                }

                areSameStablecoins = lodash_1.isEqual(lodash_1.sortBy(stableCoinAddresses.map(lodash_1.toUpper)), lodash_1.sortBy(usdTokens.map(lodash_1.toUpper)));

                if (!raisedFundsWallet) {
                  raisedFundsWallet = storageWallet;
                }

                if (!unsoldTokensWallet) {
                  unsoldTokensWallet = treasuryWallet;
                }

                if (!(!utils_1.areSameAddress(storageWallet, raisedFundsWallet) || !utils_1.areSameAddress(treasuryWallet, unsoldTokensWallet) || !areSameStablecoins)) {
                  _context2.next = 99;
                  break;
                }

                _tag5 = types_1.PolyTransactionTag.ModifyAddresses;
                addedTransactions.push(_tag5);
                _context2.next = 99;
                return this.addTransaction(stoModule.modifyAddresses, {
                  tag: _tag5,
                  resolvers: [exports.createTieredStoFactoryRefreshResolver(tieredStoFactory, addedTransactions, _tag5, tieredStoId)]
                })({
                  treasuryWallet: unsoldTokensWallet,
                  wallet: raisedFundsWallet,
                  stableTokens: stableCoinAddresses
                });

              case 99:
                if (!(addedTransactions.length === 0)) {
                  _context2.next = 101;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'Modify STO data failed: nothing to modify'
                });

              case 101:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 9]]);
      }));
    }
  }]);

  return ModifyTieredStoData;
}(Procedure_1.Procedure);

exports.ModifyTieredStoData = ModifyTieredStoData;